import React from 'react';
import AgreementRulesPageContent from '../../AgreementRules/Components/AgreementRulesPageContent';

export default function AgreementRulesPage() {
    return <AgreementRulesPageContent />;
}
